import React from 'react'
import Navbar1 from './Navbar1/Navbar1'
import Navbar2 from './Navbar2/Navbar2'

const Navbar = () => {
  return (
    <div style={{width:"80%",margin:"auto", marginRight:"900px"}}>
        <Navbar1/>
        <Navbar2/>
    </div>
  )
}

export default Navbar